<div class="config-container shadow mt-4">
  <h4 (click)="toggleCollapse(SubStepEnum.Posts)" [ngClass]="{ active: subStep === SubStepEnum.Posts }"
    class="title configurator-subtitle collapse-button">
    <span>{{ 'fence.materials.posts' | translate }}</span>
    <span class="title-count">{{ postTypes?.length }} {{ 'fence.materials.available-posts' | translate }}</span>
  </h4>

  <!-- Si un poteau est désactivée et qu'aucun devis n'est valide -->
  @if (!configuration.hasValidQuotation && configuration.postType?.isDisabled) {
  <span class="disabled-product pt-1 ml-4">{{ disableMessage }}</span>
  }

  <!-- Si un poteau est désactivée et que le devis est valide -->
  @if (configuration.hasValidQuotation && configuration.postType?.isDisabled) {
  <span class="disabled-with-quotation-product pt-1 ml-4">{{ 'fence.materials.valid-quotation-message' | translate
    }}</span>
  }

  @if (subStep === SubStepEnum.Posts) {
  <div class="collapse-block">
    <div class="posts-container">
      @for (postType of postTypes; track postType.id) {
      <div (click)="selectPostType(postType)" [class.active]="isPostTypeSelected(postType)"
        [class.disabled-card]="postType.isDisabled" class="posts-card">
        <img [src]="baseImgURL + postType.icon" alt="post-img" class="post-img" />

        <p class="post-title">
          {{ currentLang === 'fr' ? postType.nameFr : postType.nameEn }}

          @if (postType.tooltip) {
          <a class="casto-tooltip"
            (click)="modalService.displayInfo(postType.tooltip, postType.nameFr, postType.nameEn); $event.stopPropagation()">?</a>
          }
        </p>
      </div>
      } @empty {
      <ng-casto-loader></ng-casto-loader>
      }
    </div>
  </div>
  }
</div>